import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useState, useEffect } from 'react';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const target = document.querySelector(`.${styles.TheComp}`) as HTMLDivElement;
            if (target) {
                AniContainer.create({
                    triggerElement: target,
                    triggerHook: 1,
                    offset: '50%',
                    duration: target?.offsetHeight,
                    onEnter: () => setEnter(true),
                });
            }
        }
    }, []);

    // useEffect(() => {
    //     if (enter) {
    //         const targetCls = window?.innerWidth > 1440 ? 'ef-video-item-pc' : 'ef-video-item-h5';
    //         const video = document.querySelector(`.${styles.TheComp} .${targetCls}`) as HTMLVideoElement;
    //         if (video) {
    //             video.pause();
    //             video.play();
    //         }
    //     }
    // }, [enter]);

    return (
        <div className={styles.TheComp}>
            <EfSection
                isVideo={true}
                autoPlay={false}
                loop={false}
                startPlay={enter}
                position="hover"
                theme="black"
                poster="https://websiteoss.ecoflow.com/upload/image/1721182880897/pc_expandable.jpg"
                posterH5="https://websiteoss.ecoflow.com/upload/image/1721182906711/m_expandable.jpg"
                pc="https://websiteoss.ecoflow.com/upload/video/1721124950985/%E7%94%B5%E6%B1%A0%E5%A0%86%E5%8F%A0-pc.mp4"
                h5="https://websiteoss.ecoflow.com/upload/video/1721124971172/%E7%94%B5%E6%B1%A0%E5%A0%86%E5%8F%A0-m.mp4"
                title={t('G_title')}
                desc={t('G_desc')}
            />
        </div>
    );
}
